
const LandscapingGallery = () => {
  const projects = [
    {
      title: 'Residential Garden Transformation',
      location: 'Westville, Durban',
      image: 'https://public.readdy.ai/ai/img_res/641cfdfb4e417fda4c79bda9e654cc2d.jpg',
    },
    {
      title: 'Modern Garden Design',
      location: 'Hillcrest, KZN',
      image: 'https://readdy.ai/api/search-image?query=modern%20contemporary%20garden%20design%20in%20south%20africa%20with%20clean%20lines%20native%20plants%20and%20professional%20landscaping%20clean%20simple%20background%20bright%20natural%20daylight&width=600&height=400&seq=landscape2&orientation=landscape',
    },
    {
      title: 'Garden Clean-Up Project',
      location: 'Pinetown, Durban',
      image: 'https://readdy.ai/api/search-image?query=professionally%20cleaned%20and%20maintained%20garden%20in%20south%20africa%20with%20trimmed%20hedges%20neat%20lawn%20and%20organized%20plant%20beds%20clean%20simple%20background%20bright%20natural%20daylight&width=600&height=400&seq=landscape3&orientation=landscape',
    },
    {
      title: 'Commercial Landscaping',
      location: 'Durban Central',
      image: 'https://readdy.ai/api/search-image?query=professional%20commercial%20landscaping%20project%20in%20south%20africa%20with%20manicured%20lawns%20decorative%20plants%20and%20business%20property%20clean%20simple%20background%20bright%20natural%20daylight&width=600&height=400&seq=landscape4&orientation=landscape',
    },
  ];

  return (
    <div className="mb-16">
      <h2 className="font-serif text-4xl font-bold text-charcoal mb-4">
        Our Recent Projects
      </h2>
      <p className="text-gray-600 text-lg mb-12 leading-relaxed">
        See the quality of our work through recent landscaping projects across Durban and KwaZulu-Natal
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {projects.map((project, index) => (
          <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
            <div className="relative h-64 overflow-hidden">
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-300"
              />
            </div>
            <div className="p-6">
              <h3 className="font-bold text-xl text-charcoal mb-2">{project.title}</h3>
              <p className="text-gray-600 flex items-center">
                <i className="ri-map-pin-line text-primary mr-2 w-5 h-5 flex items-center justify-center"></i>
                {project.location}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LandscapingGallery;
